
import { Component, Vue, Prop} from 'vue-property-decorator';
import { namespace } from "vuex-class";  

import PageBase from "../../PageBase.vue";
import CitorSurvey from './CitorSurvey.vue';
import Tooltip from "@/components/survey/Tooltip.vue";
 
import "@/store/modules/application";
const applicationState = namespace("Application");

import { stepInfoType, stepResultInfoType } from "@/types/Application";
import { stepsAndPagesNumberInfoType } from "@/types/Application/StepsAndPages";


@Component({
    components:{
      CitorSurvey,
      PageBase,
      Tooltip
    }
})
export default class ApplicantCitor extends Vue {

    @Prop({required: true})
    step!: stepInfoType;

    @applicationState.State
    public stPgNo!: stepsAndPagesNumberInfoType;

    @applicationState.State
    public steps!: stepInfoType[];
    
    @applicationState.State
    public deceasedName!: string;

    @applicationState.Action
    public UpdateStepResultData!: (newStepResultData: stepResultInfoType) => void  

    currentStep =0;
    currentPage =0;

    applicantName = "";
    
    showTable = true;
    citorData = [];
    anyRowToBeEdited = null;
    editId = null; 
    incompleteError =  false;   
    citorCompleted = null;
    updated = 0;
    updatedCitor = 0;

    showCitorInfo = false;
    
    public openForm(anyRowToBeEdited?) {
        this.showTable = false;
         Vue.nextTick(()=>{
            const el = document.getElementById('citor-info-survey')
            if(el) el.scrollIntoView();
        })
        if(anyRowToBeEdited) {
            this.editId = anyRowToBeEdited.id;
            this.anyRowToBeEdited = anyRowToBeEdited;
        } else {
            this.anyRowToBeEdited = null;
        }
    }

    public citorComponentData(value) {  
        this.updated ++;     
        this.showTable = value;
    }

    public populateSurveyData(citorValue) {

        const currentIndexValue = this.citorData?.length > 0 ? this.citorData[this.citorData.length - 1].id : 0;
        const id = currentIndexValue + 1;
        const newCitor = { ...citorValue, id };
        this.citorData = [...this.citorData, newCitor];

        this.showTable = true; 
        this.resetCitorRelatedPages(this.citorData);
    }

    public deleteRow(rowToBeDeleted) {
       
        this.citorData = this.citorData.filter(data => {
            return data.id !== rowToBeDeleted;
        }); 
        this.resetCitorRelatedPages(this.citorData);
        this.surveyHasError();
    }

    public editRow(editedRow) {
        this.citorData = this.citorData.map(data => {
            return data.id === this.editId ? editedRow : data;
        });
        this.showTable = true;
        this.surveyHasError();
        this.resetCitorRelatedPages(this.citorData);
    }

    public onPrev() {
        Vue.prototype.$UpdateGotoPrevStepPage()
    }

    public onNext() {
        if(!this.incompleteError)    
            Vue.prototype.$UpdateGotoNextStepPage()
    }

    created() {

        if (this.step.result?.applicantCitorSurvey?.data) {
            this.citorData = this.step.result.applicantCitorSurvey.data;
        }       
        
        if (this.step.result?.citorCompleted) {
            this.citorCompleted = this.step.result.citorCompleted;
        }       
        
        if (this.step.result?.applicantInfoSurvey?.data?.applicantName){
            this.applicantName = this.step.result.applicantInfoSurvey.data.applicantName;
        }
    }

    mounted(){
        this.updated = 0;
        this.updatedCitor = 0;
        Vue.nextTick(()=>this.surveyHasError());
        this.currentStep = this.$store.state.Application.currentStep;
        this.currentPage = this.$store.state.Application.steps[this.currentStep].currentPage;        
    }

    public surveyHasError(){
        let progress = this.citorData.length==0? 50 : 100;
    
        this.incompleteError =  false;        
        for(const citor of this.citorData){
            if (!citor.applicantCitorName || !citor.applicantCitorIsAlive){            
                this.incompleteError = true;  
                progress = 50;    
                break
            }
        }        
        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, progress, false);
    }
    
    public isDisableNext() {
        return this.citorData?.length <= 0  || 
            !this.citorCompleted || this.citorCompleted == 'No';
    }

    beforeDestroy() {
        this.surveyHasError();  
        
        let citorInfo = this.getCitorResults(); 

        this.UpdateStepResultData({step:this.step, data: {applicantCitorSurvey: citorInfo, citorCompleted: this.citorCompleted}})       
    }

    public getCitorResults(){
        const questionResults: {name:string; value: any; title:string; inputType:string}[] =[];
        for(const citor of this.citorData)
        {
            questionResults.push({name:'applicantCitorSurvey', value: this.getCitorInfo(citor), title:'Citor '+citor.id +' Information', inputType:''})
        }
        
        return {data: this.citorData, questions:questionResults, pageName:'Citor Information', currentStep: this.currentStep, currentPage:this.currentPage}
    }

    public getCitorInfo(citor){

        const resultString = [];
        resultString.push(Vue.filter('styleTitle')("Name: ")+citor.applicantCitorName);        
        
        return resultString;
    }  

    public resetCitorRelatedPages(citorData?) {
    //TODO
        // const stPgNo: stepsAndPagesNumberInfoType = this.$store.state.Application.stPgNo;   
        // const p = stPgNo.RFLM;

        // const pages = [ 
        //     p.ParentingArrangements,
        //     p.ParentalResponsibilities,
        //     p.ParentingTime,
        //     p.ParentingOrderAgreement,
        //     p.BestInterestsOfChild,
        //     p.ChildSupportCurrentArrangements,
        //     p.AboutChildSupportOrder,
        //     p.SpecialAndExtraordinaryExpenses,
        //     p.ContactWithChild,
        //     p.ContactWithChildOrder,
        //     p.AboutContactWithChildOrder,
        //     p.ContactWithChildBestInterestsOfChild,
        //     p.GuardianOfChild,           
        //     p.ReviewYourAnswersRFLM
        // ]
        // Vue.filter('setProgressForPages')(p._StepNo, pages,50);    

    }
}
